import { CanDeactivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const sideMenuPurgeGuard: CanDeactivateFn<unknown> = (
  component,
  currentRoute,
  currentState,
  nextState
) => {
  const router = inject(Router);

  try {
    const nextUrlTree = router.parseUrl(nextState.url);
    const hasAuxiliaryOutlets = Object.keys(nextUrlTree.root.children).some(
      (outlet) => outlet !== 'primary'
    );

    if (!hasAuxiliaryOutlets) {
      return true;
    }

    const segments = nextUrlTree.root.children.primary?.segments || [];
    return router.createUrlTree([
      { outlets: { primary: segments.map((s) => s.path), side: null } },
    ]);
  } catch {
    return true;
  }
};
